class VouchersListCtrl {

    constructor(Vouchers, $state) {
        this.store = Vouchers;
        this.store.commit('setVm', this);
        this.store.dispatch('loadWorkflows', 'vouchers::vouchers-list');
        this.state = $state;
    }

    showDetails(payload) {
        return this.state.go('app.vouchers.main.details', {vid: payload.row.id});
    }
}

VouchersListCtrl.$inject = [
    'Vouchers',
    '$state'
];

angular
    .module('festzelt-os.vouchers.main')
    .controller('VouchersListCtrl', VouchersListCtrl);



// WEBPACK FOOTER //
// ./src/app/pages/vouchers/main/controllers/list-controller.js